var map = {
	"./MACRO_en.json": [
		247
	],
	"./MACRO_es.json": [
		7507,
		888
	],
	"./MACRO_fr.json": [
		8580,
		580
	],
	"./MACRO_it.json": [
		9629,
		629
	],
	"./MACRO_pt.json": [
		1864,
		864
	],
	"./MACRO_zh.json": [
		698,
		698
	],
	"./en.json": [
		1262,
		262
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3640;
module.exports = webpackAsyncContext;